import { render, staticRenderFns } from "./folderEditButtonComponent.vue?vue&type=template&id=3390f4fe&scoped=true&"
import script from "./folderEditButtonComponent.vue?vue&type=script&lang=js&"
export * from "./folderEditButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./folderEditButtonComponent.vue?vue&type=style&index=0&id=3390f4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390f4fe",
  null
  
)

export default component.exports